module.exports = __webpack_public_path__ + "img/rwfail.4bd31db9.svg";